// helper to fetch featured project
export const getFeaturedProject = (projects) => {
  const result = Object.entries(projects)
    .reverse()
    .find(([projID, projObj]) => projObj?.featured);

  // Return a fallback if no featured project is found
  return result || [null, null];
};
